import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ModeratorOrCustomerGuardService implements CanActivate {
  constructor(private localStorageService: LocalStorageService) {}

  canActivate(): boolean {
    const role = this.localStorageService.getItem('role');
    return role === 'employee' || role === 'administrator' || role === 'customer';
  }
}
